<template>
  <div v-if="isVisible" class="d-flex align-center">
    <v-tooltip bottom :disabled="!isDisabled">
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-btn-toggle
            :value="viewMode"
            mandatory
            dense
            color="primary"
            :disabled="isDisabled"
            @change="onChange"
          >
            <v-btn small value="AD_GROUP">Ad Group</v-btn>
            <v-btn small value="STORE">Store</v-btn>
          </v-btn-toggle>
        </div>
      </template>
      <span>Finish editing the current batch before switching views.</span>
    </v-tooltip>
  </div>
</template>

<script>
import { userAccess } from '@/mixins/user-access'

export default {
  name: 'AdminViewModeToggle',
  mixins: [userAccess],
  computed: {
    isVisible() {
      return this.adminUser && this.$auth.tenant === 'alliance-retail-group'
    },
    isDisabled() {
      return this.$route.name === 'BatchView'
    }
  },
  methods: {
    onChange(value) {
      if (value && value !== this.viewMode) {
        this.$store.commit('setViewMode', value)
      }
    }
  }
}
</script>
